import React from "react";
import { formatCampaignDate } from "../../utils/campaignDisplayUtils";
import CampaignStatusBadge from "./CampaignStatusBadge";

const getDisplayValue = (value, fallback = "Unavailable") => value ?? fallback;

const CampaignListItem = ({
    campaign = {},
    isSelected,
    selectedItemRef,
    onSelect,
}) => {
    const helperContext = campaign.ui_helper_context || {};

    return (
        <button
            type="button"
            ref={selectedItemRef}
            onClick={() => onSelect?.(campaign.sequence_id)}
            className={`w-full border-b border-slate-200 px-3 py-3 text-left transition-colors duration-200 ${
                isSelected
                    ? "border-l-4 border-l-[#f97316] bg-[#fff7ed] pl-2 shadow-[inset_0_0_0_1px_rgba(249,115,22,0.22)]"
                    : "border-l-4 border-l-transparent odd:bg-slate-50 even:bg-white hover:bg-amber-50/50"
            }`}
        >
            <div className="flex items-start justify-between gap-2">
                <p
                    className={`min-w-0 flex-1 line-clamp-2 text-sm font-semibold sm:line-clamp-1 ${
                        isSelected ? "text-[#7c2d12]" : "text-slate-900"
                    }`}
                >
                    {getDisplayValue(campaign.name, "Untitled campaign")}
                </p>
                <CampaignStatusBadge
                    status={campaign.status}
                    campaign={campaign}
                    isPaused={helperContext.is_paused}
                />
            </div>

            <div className="mt-1.5 flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                    <p className="text-xs font-semibold text-slate-400">
                        Product
                    </p>
                    <p className="truncate text-sm font-medium text-slate-700">
                        {getDisplayValue(campaign.product_name)}
                    </p>
                </div>
                <div className="shrink-0 text-right">
                    <p className="text-xs font-semibold text-slate-400">
                        Created
                    </p>
                    <p className="whitespace-nowrap text-sm font-medium text-slate-700">
                        {formatCampaignDate(campaign.created_at)}
                    </p>
                </div>
            </div>
        </button>
    );
};

export default CampaignListItem;
